<template>
    <b-card>
        <b-card-text>
            <h3 class="mb-2">
                Ημερομηνία & Τοποθεσία
            </h3>
            <p><strong>Από:</strong> {{ shortDate(congress.startDate) }}</p>
            <p><strong>Έως:</strong> {{ shortDate(congress.endDate) }}</p>
            <p><strong>Τοποθεσία:</strong> {{ congress.location }}</p>
        </b-card-text>
        <template #footer>
            <div class="d-flex justify-content-between align-items-center">
                <b-button
                    v-if="congress.adaudienceId && !!congress.submissionDeadline && isAfterNow(congress.submissionDeadline)"
                    :href="`https://www.adaudience.gr/submit-abstract/58?author_mail=${userData.email}`"
                    target="_blank"
                    variant="outline-primary"
                >
                    {{ $t('Submit Abstract') }}
                </b-button>
                <calendar-btn :congress="congress" />
            </div>
        </template>
    </b-card>
</template>
<script>
import { BCard } from 'bootstrap-vue'
import CalendarBtn from '@/components/CalendarBtn.vue'
export default {
    name: 'CongressDatesLocationCard',
    components: { BCard, CalendarBtn },
    props: {
        congress: {
            type: Object,
            required: true
        }
    },
    computed: {
        userData() {
            return this.$store.getters['app-common/userData']
        },
    }
}
</script>
